"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyByMapSafe = keyByMapSafe;
/**
 * Properly sets nullable type for members which is currently not done by
 * native lodash types
 * @param items
 * @param keyValueCallback
 * @returns
 */
function keyByMapSafe(items, keyValueCallback) {
    return items.reduce((acc, item) => {
        const [key, value] = keyValueCallback(item);
        acc[key] = value;
        return acc;
    }, {});
}
//# sourceMappingURL=key-by-map.js.map